import gql from 'graphql-tag'

const GET_SUBMITTED_TEMPLATE = gql`
  query submittedTemplates($templateCategory: String!, $isAsc: Boolean!) {
    submittedTemplates(templateCategory: $templateCategory, isAsc: $isAsc) {
      id
      status
      submittedDate
      completedDate
      adminCompleteDate
      pointsValue
      remainingPoints
      title
      description
    }
  }
`

export default GET_SUBMITTED_TEMPLATE
